module.exports = __webpack_public_path__ + "img/drh5_title_tc.f7c0717f.png";